import { gql, MutationHookOptions, useMutation } from "@apollo/client";

import {
  IncomeTaxDeclarationStatus,
  UpdateIncomeTaxDeclarationInput as GeneratedUpdateIncomeTaxDeclarationInput,
} from "../schema.generated";
import { IncomeTaxDeclaration } from "../types";

/*
 * `resetApproval` comes from the generated schema rather than being restated
 * here: it confirms that moving the declaration into "Warten auf
 * Kundenfreigabe" may reset the approval the customer gave for the previous
 * version. Without it the backend refuses that status change with
 * APPROVAL_RESET_REQUIRED. A save that leaves the status unchanged never
 * needs it.
 */
export interface UpdateIncomeTaxDeclarationInput
  extends Pick<GeneratedUpdateIncomeTaxDeclarationInput, "resetApproval"> {
  status: IncomeTaxDeclarationStatus;
}

export interface UpdateIncomeTaxDeclarationMutationVariables {
  email: string;
  year: number;
  payload: UpdateIncomeTaxDeclarationInput;
}

export interface UpdateIncomeTaxDeclarationMutationResult {
  updateIncomeTaxDeclaration: IncomeTaxDeclaration;
}

export const UPDATE_INCOME_TAX_DECLARATION_MUTATION = gql`
  mutation updateIncomeTaxDeclaration(
    $email: String!
    $year: Int!
    $payload: UpdateIncomeTaxDeclarationInput!
  ) {
    updateIncomeTaxDeclaration(email: $email, year: $year, payload: $payload) {
      status
      statusUpdatedAt
    }
  }
`;

export const useUpdateIncomeTaxDeclarationMutation = (
  options?: MutationHookOptions<
    UpdateIncomeTaxDeclarationMutationResult,
    UpdateIncomeTaxDeclarationMutationVariables
  >
) =>
  useMutation<
    UpdateIncomeTaxDeclarationMutationResult,
    UpdateIncomeTaxDeclarationMutationVariables
  >(UPDATE_INCOME_TAX_DECLARATION_MUTATION, options);
